<template>
  <div>
    <div class="results-head">
      <span class="cnt">
        <div class="skel" style="width:200px;height:18px;border-radius:6px" />
      </span>
    </div>
    <div class="res-list">
      <DoctorsListCardSkeleton v-for="i in 3" :key="i" />
    </div>
  </div>
</template>

<script>
import DoctorsListCardSkeleton from "./DoctorsListCardSkeleton.vue";

export default {
  name: "DoctorsListSkeleton",
  components: {
    DoctorsListCardSkeleton
  }
};
</script>
